import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import ExternalBrowserPlugin from '../../plugins/externalBrowser.plugin';

declare var $: any;
declare var deviceInfo: any;

declare var Capacitor;

/**
 * This class contains wrappers for various utils which work differently in browser vs mobile
 */
@Injectable()
export class HybridToolsService {
    private scrollRestore: number;

    // Since this is async, and since it really shouldn't change, we'll retrieve the details when the application starts
    async retrieveDeviceInfo() {
        deviceInfo = await Device.getInfo();
        console.log(deviceInfo);
    }

    getDeviceInfo() {
        return deviceInfo;
    }

    disableBodyScroll() {
        if (this.scrollRestore) {
            console.warn('The body scroll is already disabled.');
        }

        this.scrollRestore = $(document).scrollTop();
        $('body').css('position', 'fixed');
    }

    conditionallyDisableBodyScrollOnMobile() {
        if (this.isMobileOperatingSystem()) {
            this.disableBodyScroll();
        }
    }

    enableBodyScroll() {
        $('body').css('position', 'static');
        $(document).scrollTop(this.scrollRestore);
    }

    conditionallyEnableBodyScrollOnMobile() {
        if (this.isMobileOperatingSystem()) {
            this.enableBodyScroll();
        }
    }

    hasMobileMenuClasses() {
        return $('body').hasClass('cat__menu-left--visible--mobile');
    }

    addMobileMenuClasses() {
        $('body').addClass('cat__menu-left--visible--mobile');
        this.addMobileSafariWorkaround();
    }

    removeMobileMenuClasses() {
        $('body').removeClass('cat__menu-left--visible--mobile');
        this.removeMobileSafariWorkaround();
    }

    addMobileSafariWorkaround() {
        //see https://stackoverflow.com/a/69654353 - Thanks Apple!
        $('html').addClass('mobileSafariWorkaround');
    }

    removeMobileSafariWorkaround() {
        //see https://stackoverflow.com/a/69654353 - Thanks Apple!
        $('html').removeClass('mobileSafariWorkaround');
    }

    hardReload() {
        window.location.assign('/login');
    }

    //this doesn't really belong here, but I'm not going to create a new service for it
    canLinkToFacebook() {
        //facebook linking will still work on android, but not iOS, see MTS-4128
        //return !this.isMobileApp() || (this.isMobileApp() && this.isAndroid());
        return true;
    }

    allowThirdPartyLogin() {
        //apple doesn't allow third-party login in iOS apps unless you include sign-in with apple
        return !(this.isMobileApp() && this.isIOS());
    }

    isMobileApp() {
        //this check will work even if cordova isn't initialized yet, we can't rely on the global in index.html or on the cordova class during bootstrapping
        return Capacitor.isNativePlatform();
    }

    isMobileOperatingSystem() {
        return this.isIOS() || this.isIPadOS() || this.isAndroid() || this.isWindowsPhone();
    }

    isIOS() {
        //This will return true for all iPhones and iPads prior to iPadOS 13
        return (this.getDeviceInfo().operatingSystem === 'ios');
    }

    isIPadOS() {
        //iPads report themselves as macs from iPadOS 13 forwards
        return (this.getDeviceInfo().operatingSystem === 'mac' && (navigator.maxTouchPoints && navigator.maxTouchPoints > 2));
    }

    isSafari() {
        const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        const isMac = this.getDeviceInfo().operatingSystem === 'mac';
        const isChromish = ua.indexOf('Chrome') > 0;
        const isFirefox = ua.indexOf('Firefox') > 0;

        return (!this.isMobileApp() && (this.isIOS() || this.isIPadOS() || (isMac && !isChromish && !isFirefox)))
    }

    isAndroid() {
        return (this.getDeviceInfo().operatingSystem === 'android');
    }

    isWindowsPhone() {
        //TODO: this should be updated to use capacitor's Device plugin
        const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
        return (/windows phone/i.test(userAgent));
    }

    getOperatingSystem() {
        return this.getDeviceInfo().operatingSystem;
    }

    openExternalLink(url: string) {

        console.log(url);

        if (this.isMobileApp() && this.isIOS()) {
            ExternalBrowserPlugin.open({ "link": url });
        } else if (this.isMobileApp()) {
            window.open(url, '_system');
        } else {
            window.open(url, '_blank');
        }
    }
}
